import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '../../contexts/I18nContext';
import { openShare } from '../../lib/socialShare';

const ShareTextModal = ({ open, title, placeholder, maxLength = 2000, platform, mediaUrl, mediaType = 'image', by = '', onConfirm, onCancel, onShared }) => {
  const { t } = useI18n();
  const brand = 'Catoo AI';
  const initialTemplate = t('creationRecord.templateShareText', { brand });
  const [useTemplate, setUseTemplate] = useState(true);
  const [value, setValue] = useState(initialTemplate || '');
  const [len, setLen] = useState((initialTemplate || '').length);
  const taRef = useRef(null);
  useEffect(() => {
    if (open) {
      const tpl = t('creationRecord.templateShareText', { brand });
      setUseTemplate(true);
      setValue(tpl || '');
      setLen((tpl || '').length);
    }
  }, [open, t]);
  useEffect(() => { if (open && taRef.current) { setTimeout(()=>taRef.current.focus(), 10); } }, [open]);
  if (!open) return null;
  const remaining = typeof maxLength === 'number' ? Math.max(0, maxLength - len) : undefined;
  return (
    <div className="share-modal" onClick={onCancel} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200 }}>
      <div className="share-modal__content" onClick={(e)=>e.stopPropagation()} style={{ width: 'min(640px, 92vw)', background: 'linear-gradient(135deg, #0b1220 0%, #0a0f18 100%)', border: '1px solid #334155', borderRadius: 14, boxShadow: '0 16px 40px rgba(0,0,0,0.5)' }}>
        <div className="share-modal__header" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '16px 18px', borderBottom: '1px solid #1f2531' }}>
          <div style={{ width: 32, height: 32, borderRadius: 10, background: 'rgba(16,185,129,0.18)', border: '1px solid rgba(16,185,129,0.4)', display: 'grid', placeItems: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v16H4z" stroke="#10b981" strokeWidth="2"/><path d="M7 9h10M7 13h10" stroke="#10b981" strokeWidth="2" strokeLinecap="round"/></svg>
          </div>
          <div style={{ fontWeight: 700, color: '#e5e7eb', fontSize: 16 }}>{title || t('creationRecord.enterShareText')}</div>
          <button onClick={onCancel} style={{ marginLeft: 'auto', width: 34, height: 34, borderRadius: 10, border: '1px solid #334155', background: '#1f2937', color: '#e5e7eb', display: 'grid', placeItems: 'center' }}>×</button>
        </div>
        <div className="share-modal__body" style={{ padding: 18 }}>
          <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginBottom: 10, color: '#cbd5e1', fontSize: 14 }}>
            <span>{t('creationRecord.useTemplate')}</span>
            <input
              type="checkbox"
              checked={useTemplate}
              onChange={(e) => {
                const checked = e.target.checked;
                setUseTemplate(checked);
                if (checked) {
                  const tpl = t('creationRecord.templateShareText', { brand });
                  setValue(tpl || '');
                  setLen((tpl || '').length);
                } else {
                  setValue('');
                  setLen(0);
                }
              }}
              style={{ width: 16, height: 16 }}
            />
          </label>
          <div style={{ position: 'relative' }}>
            <textarea
              ref={taRef}
              className="share-modal__textarea"
              placeholder={placeholder || t('creationRecord.enterShareText')}
              value={value}
              onChange={(e)=>{ setValue(e.target.value); setLen(e.target.value.length); }}
              maxLength={maxLength}
              style={{ width: '100%', minHeight: 140, resize: 'vertical', background: '#0a0f18', color: '#e5e7eb', border: '1px solid #334155', borderRadius: 12, padding: '12px 12px 36px', lineHeight: 1.6, outline: 'none' }}
            />
            <div className="share-modal__counter" style={{ position: 'absolute', right: 12, bottom: 8, color: '#94a3b8', fontSize: 12 }}>{len}{typeof remaining==='number' ? ` / ${maxLength}` : ''}</div>
          </div>
        </div>
        <div className="share-modal__footer" style={{ padding: '12px 18px', borderTop: '1px solid #1f2531', display: 'flex', justifyContent: 'space-between', gap: 10 }}>
          <button onClick={onCancel} style={{ padding: '10px 16px', borderRadius: 10, background: '#1f2937', color: '#e5e7eb', border: '1px solid #334155', fontWeight: 600 }}>{t('common.cancel')}</button>
          <div style={{ display: 'flex', gap: 10 }}>
            <button
              onClick={() => {
                const textX = (value || '').slice(0, 280);
                openShare('x', { text: textX, mediaUrl});
                if (typeof onShared === 'function') onShared({ platform: 'x', text: textX, mediaUrl});
                if (typeof onConfirm === 'function') onConfirm(textX);
              }}
              style={{ padding: '10px 18px', borderRadius: 10, background: 'linear-gradient(135deg, #10b981 0%, #0ea5e9 100%)', color: '#06251f', border: 'none', fontWeight: 800, boxShadow: '0 8px 24px rgba(16,185,129,0.35)' }}
            >
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <span>Share to</span>
                <img src="/icons/x.svg" alt="X" style={{ width: 16, height: 16 }} />
              </span>
            </button>
            <button
              onClick={() => {
                const textFb = value || '';
                openShare('facebook', { text: textFb, mediaUrl});
                if (typeof onShared === 'function') onShared({ platform: 'facebook', text: textFb, mediaUrl});
                if (typeof onConfirm === 'function') onConfirm(textFb);
              }}
              style={{ padding: '10px 18px', borderRadius: 10, background: 'linear-gradient(135deg, #2563eb 0%, #10b981 100%)', color: '#06251f', border: 'none', fontWeight: 800, boxShadow: '0 8px 24px rgba(37,99,235,0.35)' }}
            >
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <span>Share to</span>
                <img src="/icons/facebook.svg" alt="Facebook" style={{ width: 16, height: 16 }} />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareTextModal;
